import React from 'react';
import styled from 'styled-components';
import getConfig from 'next/config';
import { Form } from "react-bootstrap";

import { hexToRGBA } from '../../../utils/theme';

const { publicRuntimeConfig } = getConfig();

const StyledGroup = styled(Form.Group)`
  padding-left: 0;
  padding-right: 0;
  
  input:checked,
  input:not(:checked) {
    position: absolute;
    left: -9999px;
  }

  input:checked + label,
  input:not(:checked) + label {
    display: inline-block;
    position: relative;
    padding-left: 32px;

    font-family: 'LatoRegular';
    font-size: 14px;
    line-height: 24px;
    color: ${hexToRGBA('#1B3858', 0.7)};

    cursor: pointer;
  }

  input:checked + label:before {	
    content: '';
    display: inline-block;
    position: absolute;
    left: 0px;
    top: 1px;
    background: ${`url(${publicRuntimeConfig.basePath}/icons/V2/checkbox_checked.svg)`} no-repeat center; 
    width: 22px;
    height: 22px; 
    padding: 7px;
  }

  input:not(:checked) + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 1px;
    width: 22px;
    height: 22px;
    border: 2px solid ${hexToRGBA('#1B3858', 0.5)};
    border-radius: 2px;
    background: #FFFFFF;
  }
`;

const StyledCheck = styled(Form.Check)`
  margin-right: 24px;

  @media ${({ theme }) => theme.devices.tablet} {
    margin-top: 12px;
  }
`;

function Switch({
  id,
  labelOn = "Label ON",
  labelOff = "Label OFF",
  valueOn,
  valueOff,
  value,
  onChange,
}) {
  return (
    <StyledGroup controlId={id}>
      <StyledCheck
        inline
        id={`${id}1`}
        label={labelOff}
        name={id}
        type="radio"
        value={valueOff}
        checked={value === valueOff}
        onChange={onChange}
      />
      <StyledCheck
        inline
        id={`${id}2`}
        label={labelOn}
        name={id}
        type="radio"
        value={valueOn}
        checked={value === valueOn}
        onChange={onChange}
      />
    </StyledGroup>
  );
}

export default Switch;
